import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Offcanvas, Button, Spinner } from "react-bootstrap";
import { HiOutlineArrowLeftOnRectangle } from "react-icons/hi2";
import NavigationMenu from "../NavigationMenu/NavigationMenu";
import LocationBadge from "../../common/Badge/LocationBadge/LocationBadge";
import ManualLocationSelector from "../../common/ManualLocationSelector/ManualLocationSelector";
import UserMiniCard from "../../common/UserMiniCard/UserMiniCard";
import useLogout from "../../../features/auth/hooks/useLogout";
import { useLocation } from "../../../features/location/context/LocationContext";
import "./MobileOffcanvasNav.css";
export default function MobileOffcanvasNav({
  show,
  onHide,
  user
}) {
  useLanguage();
  const {
    handleLogout,
    isLoggingOut
  } = useLogout();
  const {
    detectedCity,
    isDetectingLocation
  } = useLocation();
  const resolvedName = user?.name || user?.full_name || user?.fullName || "BaytBuddy User";
  const resolvedEmail = user?.email || "";
  const badgeCity = detectedCity || "";
  return <Offcanvas show={show} onHide={onHide} placement="start" className="bb-mobile-offcanvas">

      <Offcanvas.Header closeLabel={t("Close")} closeButton>
        <Offcanvas.Title className="bb-mobile-offcanvas__title">{t("BaytBuddy")}

        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body className="bb-mobile-offcanvas__body">
        <div className="bb-mobile-offcanvas__top">
          <LocationBadge city={isDetectingLocation ? "Detecting..." : badgeCity || "Location unavailable"} />


          <ManualLocationSelector compact onAfterSelect={onHide} />
        </div>

        <div className="bb-mobile-offcanvas__middle">
          <NavigationMenu onNavigate={onHide} />
        </div>

        <div className="bb-mobile-offcanvas__bottom">
          <UserMiniCard name={resolvedName} email={resolvedEmail} />

          <Button variant="outline-danger" className="bb-mobile-offcanvas__logout-btn" onClick={() => handleLogout({
          onBeforeRedirect: onHide
        })} disabled={isLoggingOut}>

            {isLoggingOut ? <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-2" />{t("Logging out...")}


            </> : <>
                <HiOutlineArrowLeftOnRectangle className="me-2" />{t("Logout")}

            </>}
          </Button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>;
}
